import {
  ServiceRequestFieldType,
  ServiceRequestStep,
  ServiceRequestStepType,
} from '@domain/types';

export const addressStep: ServiceRequestStep = {
  type: ServiceRequestStepType.DETAILS,
  inSummary: true,
  title: `quote:address.title`,
  segmentEvent: `Additional Info Filled in`,
  fields: [
    {
      type: ServiceRequestFieldType.ADDRESS,
      summaryTitle: `quote:address.summaryTitle`,
      props: {
        name: `full_address`,
        placeholder: `quote:selfQualif.steps.location.street.summaryTitle`,
        validation: [`isRequired`],
      },
    },
    {
      type: ServiceRequestFieldType.CHECKBOX,
      summaryTitle: `quote:address.nested_summaryTitle`,
      props: {
        name: `common_building`,
        placeholder: `quote:address.common_building`,
      },
    },
  ],
};
